import { Entry } from '../Entry'

export function Entry20250604() {
  return (
    <Entry title="2025 Jun 4 - v3.10.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17844/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
